import Vue from 'vue';

import { QueriesTypeEnum } from '../../../enums';

import { AnalyticsState, MutationClass } from '../../../models';

export class SetQueriesDataMutation implements MutationClass {

  public static execute(state: AnalyticsState, payload: { data: any; queriesType: QueriesTypeEnum; }): void {
    if (!state.data.queries[payload.queriesType]) {
      Vue.set(state.data.queries, payload.queriesType, payload.data);
    } else {
      state.data.queries[payload.queriesType] = payload.data;
    }
  }

}
